import { RESIDENTIAL_OPTIONS } from 'components/Signup/helpers/form.helpers';
import { normaliseState } from 'components/Signup/helpers/stateNormalisation';
import { UK_LOCALE } from 'utils/i18n';

type TResidentialAddress = NonNullable<
  ReturnType<typeof normaliseState>['guarantors']
>[number]['residentialAddresses'][number];

export const formatDOB = (
  dobDay?: string,
  dobMonth?: string,
  dobYear?: string,
) => {
  // Shouldn't occur: Step 1 signup always has the full date of birth. Added this to satisfy TypeScript
  if (!dobDay || !dobMonth || !dobYear) {
    return '';
  }

  return new Intl.DateTimeFormat(UK_LOCALE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(
    new Date(parseInt(dobYear), parseInt(dobMonth) - 1, parseInt(dobDay)),
  );
};

export const formatResidentialAddresses = (
  addresses: TResidentialAddress[],
) => {
  if (!addresses?.length) return [];

  return addresses.map((address) => {
    const houseNameOrNumber =
      address.house_number?.trim() || address.house_name?.trim() || '';
    const postcode = address.postcode
      ? address.postcode.trim().replace(/\s+/g, ' ').toUpperCase()
      : '';

    const formattedAddress = [
      houseNameOrNumber,
      address.street_line_1,
      address.street_line_2,
      address.town,
      postcode,
    ]
      .filter(Boolean)
      .join(', ');

    const statusLabel =
      RESIDENTIAL_OPTIONS.find(
        (opt) => opt.value === address.residential_status,
      )?.label || '';

    return { formattedAddress, residentialStatus: statusLabel };
  });
};

export const pluralize = (word: string, count: number) => {
  if (count === 1) return word;
  return word + (word.endsWith('s') ? 'es' : 's');
};
